module.exports = __webpack_public_path__ + "img/withdraw.9d27aad2.png";